import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import * as actions from '../../store/actions/index';
import Text from '../../components/Text/Text';
import './Preface.css';

const Preface = (props) => {
  const { onDataPreface } = props;

  useEffect(() => {
    onDataPreface();
  }, [onDataPreface]);

  return (
    <div className='mx-6 p-5 bg-white rounded'>
      <Text><div className='preface text-grey-darker' dangerouslySetInnerHTML={{ __html: props.text }} /></Text>
    </div>
  )
}

const mapsStateToProps = state => {
  return {
    text: state.text,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onDataPreface: () => dispatch(actions.getPreface())
  }
}

export default connect(mapsStateToProps, mapDispatchToProps)(Preface);
